export function partnersSlider() {
    $(".partners-slider").slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        fade: true,
        adaptiveHeight: true,
        dots: true
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/partnersSlider.js